import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PrimaryButton, SmallButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { RAISED_SMALL_BUTTONS, RAISED_SMALL_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";

const RaisedSmallButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={SmallButton} span={RAISED_SMALL_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn size="sm" color="primary" className="btn-pill btn-air-primary" id="Tooltip-15">{PrimaryButton}</Btn>
        <ToolTip target="Tooltip-15" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary btn-air-primary btn-sm</ToolTip>
        {RAISED_SMALL_BUTTONS_LIST.map((data, index) => (
          <CommonRaisedButton key={index} item={data} size="sm" />
        ))}
      </CardBody>
    </Card>
  );
};

export default RaisedSmallButtons;
